import { orderData } from '../orderData';
import { currentCurrency } from '../step2/currentCurrency';

// =====================================
// Селектори
// =====================================
const refs = {
  paymentDate: document.getElementById('payment-data'),
  paymentTime: document.getElementById('payment-time'),

  firstTripDate: document.getElementById('firstTrip-date-step3'),
  orderGetIn: document.getElementById('firstTrip-get-in-step3'),
  orderGetOut: document.getElementById('firstTrip-get-out-step3'),
  firstTripPrice: document.getElementById('firstTrip-price-step3'),

  returnTripWrapper: document.getElementById('returnTrip-wrapper-step3'),
  returnDate: document.getElementById('returnTrip-date-step3'),
  returnGetIn: document.getElementById('returnTrip-get-in-step3'),
  returnGetOut: document.getElementById('returnTrip-get-out-step3'),
  returnTripPrice: document.getElementById('returnTrip-price-step3'),

  totalElInfo: document.querySelector('.cars__price-value-info'),
};
const {
  orderGetIn,
  orderGetOut,
  firstTripDate,
  firstTripPrice,
  returnTripWrapper,
  returnGetIn,
  returnGetOut,
  returnDate,
  returnTripPrice,
  totalElInfo,
} = refs;

// =====================================
// Функція рендеру інформації в крок 3 (оплата)
// =====================================
export const renderInfoOrder = () => {
  if (orderData?.trip?.from?.address && orderData?.trip?.to?.address) {
    firstTripDate.textContent = orderData.trip.time;
    orderGetIn.textContent = orderData.trip.from.address;
    orderGetOut.textContent = orderData.trip.to.address;
    firstTripPrice.textContent = `${orderData.totalTripPrice} ${currentCurrency.symbol}`;
  }

  if (orderData?.returnTrip) {
    returnTripWrapper.style.display = 'block';

    returnDate.textContent = orderData.returnTripTime;

    returnGetIn.textContent = orderData.trip.to.address;
    returnGetOut.textContent = orderData.trip.from.address;
    returnTripPrice.textContent = `${orderData.totalTripPrice} ${currentCurrency.symbol}`;
  }

  if (orderData.totalOrderPrice) {
    totalElInfo.textContent = `${orderData.totalOrderPrice} ${currentCurrency.symbol}`;
  }
};
